/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CommentOut
 */
export interface CommentOut {
    /**
     * 
     * @type {string}
     * @memberof CommentOut
     */
    comment: string;
    /**
     * 
     * @type {number}
     * @memberof CommentOut
     */
    commentId: number;
    /**
     * 
     * @type {Date}
     * @memberof CommentOut
     */
    modificationDate: Date;
}

export function CommentOutFromJSON(json: any): CommentOut {
    return CommentOutFromJSONTyped(json, false);
}

export function CommentOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'comment': json['comment'],
        'commentId': json['commentId'],
        'modificationDate': (new Date(json['modificationDate'])),
    };
}

export function CommentOutToJSON(value?: CommentOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'comment': value.comment,
        'commentId': value.commentId,
        'modificationDate': (value.modificationDate.toISOString()),
    };
}


